import React,{useRef, useEffect} from 'react';
import "./Fight.scss";
import { GA_Push } from "../Services/GoogleAnalytics";
import { mobile } from "../Services/Agent";
import { items } from "./Fight.json"

function vw1920(px) {
    return (px/1920) *100;
}

const Fight = () => {
    let scrollRef = useRef();
    let demoScrollerRef = useRef();

    //Upper Scroll magic trick 
    useEffect(() => {
        let widthCalc = (items.length * vw1920(420)) + (items.length * vw1920(200)) + "vw"
        demoScrollerRef.current.style.width = widthCalc
        let wrapper1 = document.querySelector('.slider_wrapper');
        // let wrapper1 = scrollRef
        let wrapper2 = document.querySelector('.scroll_wrapper');
        wrapper1.onscroll = function() {
        wrapper2.scrollLeft = wrapper1.scrollLeft;
        };
        wrapper2.onscroll = function() {
        wrapper1.scrollLeft = wrapper2.scrollLeft;
        };
    })

    //Slide\Swipe Events Observer
    useEffect(() => {
        //Sets the Observer options
        const options = {
          root: null, // The view port
          threshhold: 0.5, // 0 ~ 1
          rootMargin: "0px", // like margin in css
        };
        let id = 0
        const observer = new IntersectionObserver(function (entries, observer) {
          entries.map((entry ,i ) => {
            if (!entry.isIntersecting)return;
            id++
            switch (id){
                case ~~(items.length/4)+1:
                    GA_Push("navigation_events" , "25%" ,entry.target.childNodes[0].innerText , "navigation" )
                    break;
                case ~~(items.length/2):
                    GA_Push("navigation_events" , "50%" ,entry.target.childNodes[0].innerText , "navigation" )
                    break;
                case ~~(items.length/1.3):
                    GA_Push("navigation_events" , "75%" ,entry.target.childNodes[0].innerText , "navigation" )
                    break;
                case ~~(items.length):
                    GA_Push("navigation_events" , "100%" ,entry.target.childNodes[0].innerText , "navigation" )
                    break;
                
                default:
                    return;
            }
            // GA_Push("navigation_events" , mobile() ? "Swipe" : "Slide" ,entry.target.childNodes[0].innerText , "navigation" )
            observer.unobserve(entry.target);
            })
        }, options);
        const wantedNodes = document.querySelectorAll(".watch_item");
        wantedNodes.forEach((li) => {
          observer.observe(li);
        });
      }, []);

    return (
        <section className="fight watch">
            <div className="fight_title">הקרב על ההר<div className="rect"></div><div className="top_line"></div></div>
            <div className="scroll_wrapper">
                <div className="scroller" ref={demoScrollerRef}></div>
            </div>
            <div className="slider_wrapper" ref={scrollRef}>
                {
                    items.map((a , i) => (
                        <div key={a.title} className={`slider_item watch_item`}>
                            <div className="img_title_wrapper">
                                <div className={`img img_${i+1}`}></div>
                                <div className="title_number_wrapper">
                                    <div className="number">{i+1}</div>
                                    <div className="si_title">{a.title}</div>
                                </div>
                            </div>
                                <div className="si_desc">{a.desc}</div>
                        </div>
                    ))
                }
            </div>
        </section>
    )
}

export default Fight;